"use strict";

exports.__esModule = true;
exports.ChevronDown = ChevronDown;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ChevronDown(props) {
  return _react["default"].createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h16v16H0z"
  }), _react["default"].createElement("path", {
    stroke: "#FFF",
    strokeWidth: ".5",
    fill: "currentColor",
    d: "M3.41 5L8 9.58 12.59 5 14 6.41l-6 6-6-6z"
  })));
}